import { DeleteEntityDialog } from "@/components/common/delete-entity-dialog";
import { useDeleteProductCategory } from "@/hooks/products/use-product-categories";
import type { ProductCategory } from "@/types/products/api-types/product-category-types";

interface DeleteCategoryDialogProps {
  category: ProductCategory | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteCategoryDialog({
  category,
  open,
  onOpenChange,
}: DeleteCategoryDialogProps) {
  const deleteCategory = useDeleteProductCategory();

  return (
    <DeleteEntityDialog
      entity={category}
      open={open}
      onOpenChange={onOpenChange}
      entityName="Category"
      onDelete={async (id) => {
        await deleteCategory.mutateAsync(id);
      }}
      isDeleting={deleteCategory.isPending}
      conflictMessage={`Cannot delete category "${category?.name}" because it has associated products`}
    />
  );
}
